import { Device } from '@weave/schema-gen-ts/dist/schemas/phone/callgroup/v1/callgroup.pb';
import { CreateResponse } from '@weave/schema-gen-ts/dist/schemas/phone/callgroup/v1/callgroup_service.pb';
import { CallGroupTypes } from '@frontend/api-call-group';
import { ForwardingNumberTypes } from '@frontend/api-forwarding-number';
import { AssignDeviceTypes } from '@frontend/assign-device-api';
import { SettingsTenantLocation } from '@frontend/phone-config';
import { theme } from '@frontend/theme-original';
import { Modal, ModalControlModalProps } from '@frontend/design-system';
import { AssignDeviceContent } from '../common/assign-device-content';

type ModalProps = {
  tenantLocation: SettingsTenantLocation | undefined;
  callForwardingNumbers?: ForwardingNumberTypes.FwdNumberModel[];
  callGroup: CreateResponse;
  devices?: CallGroupTypes.SipProfileType[];
  locationsNames: Record<string, string>;
  ringtone: string;
  modalProps: ModalControlModalProps;
  preSelectedSipProfileIDs: string[];
  setPreSelectedSipProfileIDs: (value: string[]) => void;
  preSelectedForwardingNumbers: string[];
  setPreSelectedForwardingNumbers: (value: string[]) => void;
  subtitle: string;
  tabsToHide?: AssignDeviceTypes.AssignDevicesTab[];
  title: string;
  isMultiLocation?: boolean;
  onDeferredSave?: (devices: Device[]) => void;
};

export const NewAssignDeviceModal = (props: ModalProps) => {
  const { modalProps, ...contentProps } = props;

  const resetState = (reset: boolean) => {
    if (reset) {
      contentProps.setPreSelectedSipProfileIDs(contentProps.preSelectedSipProfileIDs ?? []);
      contentProps.setPreSelectedForwardingNumbers(contentProps.preSelectedForwardingNumbers ?? []);
      modalProps.onClose();
    }
  };

  return (
    <Modal {...modalProps} minWidth={800} css={{ padding: theme.spacing(3) }} onClose={() => resetState(true)}>
      <AssignDeviceContent {...props} />
    </Modal>
  );
};
